<template src="../../templates/form/building-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { mapActions, mapMutations } from 'vuex'
import { required, minLength, maxLength, integer, minValue } from 'vuelidate/lib/validators'


export default {
    name: 'BuildingForm',
    props: ['buildingToUpdate'],
    components: {
        Modal
    },
    data() {
        return {
            building: {
                name: '',
                type: 'stabling',
                maximumCapacity: 0,
                farmId: null
            }
        }
    },
    computed: {
        isFormValid() {
            return this.building.id != null
                ? !this.$v.building.name.$invalid &&
                      !this.$v.building.maximumCapacity.$invalid &&
                      (this.building.name !== this.buildingToUpdate.name ||
                          this.building.maximumCapacity !== this.buildingToUpdate.maximumCapacity)
                : !this.$v.building.name.$invalid && !this.$v.building.maximumCapacity.$invalid
        }
    },
    created() {
        this.building = {
            id: this.buildingToUpdate.id,
            farmId: this.buildingToUpdate.farmId,
            name: this.buildingToUpdate.name,
            maximumCapacity: this.buildingToUpdate.maximumCapacity,
            type: this.buildingToUpdate.type
        }
    },
    validations: {
        building: {
            name: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(15)
            },
            maximumCapacity: {
                required,
                integer,
                minValue: minValue(1)
            }
        }
    },
    methods: {
        ...mapActions(['createBuilding', 'updateBuilding', 'deleteBuilding']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            if (this.isFormValid) {
                if (this.building.id === null) {
                    this.createBuilding(this.building)
                } else {
                    this.updateBuilding(this.building)
                }
                this.close()
            }
        }
    }
}
</script>

<style lang="sass">
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'

    #building-modal
        .modal-container
            .modal-header
                background-color: $dd-light-orange
                color: white
            .modal-body
                form
                    input
                        border-left: 8px solid $dd-light-orange
                    input:focus
                        border-left: 8px solid $dd-light-orange
                    input:valid
                        border-left: 8px solid $dd-light-orange
                    .select
                        @include flex-center
                        .form-select
                            width: 100%
                            height: 40px
                            background: url('/img/br_down.png') 96% no-repeat #fff
                            border-left: 8px solid $dd-light-orange
                            border-bottom: none
                            border-right: none
                            border-top: transparent
                            padding: 0.25em
                            font-size: 16px
                            font-weight: bold
                            -webkit-appearance: none
                            -moz-appearance: none
                            appearance: none
</style>
